import util from '../util'

let controller = 'Bancos'

export default Object.assign({}, util.GetCrud(controller, null), {
  GetBancosInternos: function () {
    return util.Axios.Get(controller + '/Internos')
  },
  GetBancosParceiros: function () {
    return util.Axios.Get(controller + '/Parceiros')
  },
  GetByNumero: function (dto) {
    return util.Axios.Get(controller + '/GetByNumero', dto)
  },
  AdicionarListaBancos: function (dto) {
    return util.Axios.Post(controller + '/ListaBancosNovos', dto)
  }
})
